import dayjs from 'dayjs'
import { Button, Spinner } from 'react-bootstrap'
import { useQsFilters } from '../../hooks/filters'
import { useInterventiCalendario } from '../../hooks/interventi'
// locaalize dayjs
import { ViewContentArg } from '@fullcalendar/core/index.js'
import dayGridPlugin from '@fullcalendar/daygrid'
import FullCalendar from '@fullcalendar/react'
import { fetchApi } from '@inmagik/react-crud'
import classNames from 'classnames'
import 'dayjs/locale/it'
import duration from 'dayjs/plugin/duration'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../auth'
import { SegmentedControlLink } from '../../components/SegmentedControlLink'
import { API_URL, INTERVENTI_OPTIONS_TAB } from '../../constants'
import { useIsCliente } from '../../utils/utils'
import ModalPianificazionePeriodica from '../Interventi/ModalPianificazionePeriodica'
import ModalPianificazioneTaratura from '../Interventi/ModalPianificazioneTaratura'

dayjs.locale('it')
dayjs.extend(duration)

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  search: params.get('search') ?? '',
  ordering: params.get('ordering') ?? 'data',
  data_intervento__gte: params.get('data_intervento__gte') ?? dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
  data_intervento__lte: params.get('data_intervento__lte') ?? dayjs().add(1, 'month').format('YYYY-MM-DD'),
  rapporto_taratura: params.get('rapporto_taratura') ?? 'true',
  verifica_periodica: params.get('verifica_periodica') ?? 'true',
})

export default function InterventiCalendario() {
  const isCliente = useIsCliente()
  const { filters, setFilters } = useQsFilters(initFilters)
  const {
    data: interventi,
    refetch,
    isFetching,
  } = useInterventiCalendario({
    search: filters.search,
    ordering: filters.ordering,
    data_intervento__gte: filters.data_intervento__gte,
    data_intervento__lte: filters.data_intervento__lte,
    rapporto_taratura: filters.rapporto_taratura,
    verifica_periodica: filters.verifica_periodica,
  })

  const [modalStatePianificaPeriodica, modalActionsPianificaPeriodica] = useModalTrigger()
  const [modalStatePianificaTaratura, modalActionsPianificaTaratura] = useModalTrigger()

  const { tokens } = useAuth()

  const events = useMemo(() => {
    if (!interventi) return []

    // Helper function to parse HH:mm:ss into total seconds
    const parseDuration = (duration: string) => {
      const [hours, minutes, seconds] = duration?.split(':')?.map(Number)
      return hours * 3600 + minutes * 60 + seconds
    }

    // Helper function to format total seconds back into HH:mm:ss
    const formatDuration = (totalSeconds: number) => {
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60
      return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    }

    // Map events from `interventi`
    const mappedEvents = interventi.map((intervento) => ({
      title: intervento.nome_cliente,
      pk: intervento.id,
      start: intervento.data_intervento,
      tipo_intervento: intervento.tipo_intervento,
      sede: intervento?.sede_data?.numero_rea,
      end: dayjs(intervento.data_intervento).add(4, 'hour').format(),
      pk_cliente: intervento.pk_cliente,
      operatori_count: intervento.utente ? 1 : 0,
      tempo_intervento: intervento.tempo_intervento ?? 0,
      durata_stimata: intervento.durata_stimata ?? '', // Kept as string for manual parsing
      bilance_count: 1,
    }))

    // Group and combine events
    const groupedEvents = mappedEvents.reduce((acc: any[], event: any) => {
      const existingEvent = acc.find(
        (e: any) =>
          dayjs(e.start).isSame(dayjs(event.start), 'day') &&
          e.title === event.title &&
          e.tipo_intervento === event.tipo_intervento
      )

      if (existingEvent) {
        // const existingDuration = existingEvent.durata_massima
        //   ? parseDuration(existingEvent.durata_stimata)
        //   : 0
        // const eventDuration = event.durata_stimata ? parseDuration(event.durata_stimata) : 0
        // const totalDuration = existingDuration + eventDuration

        // Update existing event
        Object.assign(existingEvent, {
          end: event.end,
          bilance_count: existingEvent.bilance_count + event.bilance_count,
          operatori_count: existingEvent.operatori_count + event.operatori_count,
          tempo_intervento: existingEvent.tempo_intervento + event.tempo_intervento,
          // durata_stimata: totalDuration !== 0 ? formatDuration(totalDuration) : '',
        })
      } else {
        acc.push(event)
      }

      return acc
    }, [])

    return groupedEvents
  }, [interventi])

  return (
    <div className="page">
      <div className="row mt-4">
        <div className="col-12 d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <h1 className="title">Interventi programmazione</h1>
            {isFetching && <Spinner animation="border" role="status" className="ms-4" variant="secondary" size="sm" />}
          </div>
        </div>
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <SegmentedControlLink
              value={INTERVENTI_OPTIONS_TAB.programmazione.value}
              options={Object.values(INTERVENTI_OPTIONS_TAB)}
            />
            {!isCliente && (
              <div className="d-flex align-items-center">
                <Button
                  onClick={() => {
                    modalActionsPianificaPeriodica.open()
                  }}
                  variant="white"
                  className="text-white d-flex align-items-center btn-outline-periodico"
                  type="button"
                >
                  <span
                    className="material-icons me-2"
                    style={{
                      fontSize: '16px',
                    }}
                  >
                    edit_calendar
                  </span>
                  <span> Pianifica periodica</span>
                </Button>
                <Button
                  onClick={() => {
                    modalActionsPianificaTaratura.open()
                  }}
                  variant="white"
                  className="text-white d-flex align-items-center ms-2 btn-outline-taratura"
                  type="button"
                >
                  <span
                    className="material-icons me-2"
                    style={{
                      fontSize: '16px',
                    }}
                  >
                    edit_calendar
                  </span>
                  <span> Pianifica taratura</span>
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="col-12 mt-3">
          <div className="bg-white p-2 border-bottom d-flex justify-content-between align-items-center w-100 rounded h-100 position-relative">
            <div className="position-absolute d-flex align-items-center" style={{ top: 20, right: 20, zIndex: 2 }}>
              <div className="d-flex align-items-center">
                <label className="label-m text-body-secondary me-2">V. Periodica</label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={filters.verifica_periodica === 'true'}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        verifica_periodica: e.target.checked ? 'true' : 'false',
                      })
                    }}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              <div className="d-flex align-items-center ms-2">
                <label className="label-m text-body-secondary me-2">R. Taratura</label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={filters.rapporto_taratura === 'true'}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        rapporto_taratura: e.target.checked ? 'true' : 'false',
                      })
                    }}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            <FullCalendar
              plugins={[dayGridPlugin]}
              initialView="dayGridWeek"
              titleFormat={{ year: 'numeric', month: 'long' }}
              events={events}
              dragScroll={false}
              dayHeaderContent={(args) => {
                const isToday = dayjs(args.date).isSame(dayjs(), 'day')
                return (
                  <div className="d-flex justify-content-start flex-column">
                    <div className="p-lg text-decoration-none">{dayjs(args.date).format('dddd')}</div>
                    {args.view.type !== 'dayGridMonth' && (
                      <div
                        className={classNames({
                          'heading-h5 day-calendar': !isToday,
                          'today-calendar': isToday,
                        })}
                      >
                        {dayjs(args.date).format('DD')}
                      </div>
                    )}
                  </div>
                )
              }}
              height={'calc(100vh - 230px)'}
              headerToolbar={{
                left: 'title prev,next',
                center: 'today dayGridWeek,dayGridMonth',
                right: '',
              }}
              datesSet={(info) => {
                setFilters({
                  data_intervento__gte: dayjs(info.start).format('YYYY-MM-DD'),
                  data_intervento__lte: dayjs(info.end).format('YYYY-MM-DD'),
                })
              }}
              buttonText={{
                today: 'Oggi',
                month: 'Mese',
                week: 'Settimana',
              }}
              locale="it"
              viewClassNames={(arg: ViewContentArg): string | string[] => {
                return arg.view.type === 'dayGridMonth' ? 'month-view' : 'week-view'
              }}
              eventContent={(args) => {
                // check wich is the current view
                const view = args.view.type
                if (view === 'dayGridMonth') {
                  // count how many events are in the same day and show only one event with the count of the others

                  const eventsInSameDayInterventoPeriodico = events.reduce(
                    (acc: number, e: any) =>
                      dayjs(e.start).isSame(dayjs(args.event.start), 'day') &&
                      e.tipo_intervento === 'verifica_periodica'
                        ? acc + e.bilance_count
                        : acc,
                    0
                  )

                  const eventsInSameDayRapportoTaratura = events.reduce(
                    (acc: number, e: any) =>
                      dayjs(e.start).isSame(dayjs(args.event.start), 'day') && e.tipo_intervento === 'rapporto_taratura'
                        ? acc + e.bilance_count
                        : acc,
                    0
                  )

                  // check if there

                  return (
                    <Link
                      to={`/interventi/?data_intervento__gte=${dayjs(args.event.start).format(
                        'YYYY-MM-DD'
                      )}&data_intervento__lte=${dayjs(args.event.end).format('YYYY-MM-DD')}`}
                      className="no-link w-100"
                    >
                      <div className="p-2 w-100">
                        <div
                          style={{
                            borderLeft: `4px solid var(--rapporto-taratura-strong)`,
                            backgroundColor: 'var(--rapporto-taratura-light)',
                          }}
                          className="p-2 w-100"
                        >
                          <div className="p-sm text-rapporto-taratura d-flex justify-content-between align-items-center w-100">
                            <span>{eventsInSameDayRapportoTaratura > 1 ? 'Tarature' : 'Taratura'}</span>
                            {eventsInSameDayRapportoTaratura}{' '}
                          </div>
                        </div>
                        <div
                          style={{
                            borderLeft: `4px solid var(--intervento-periodico-strong)`,
                            backgroundColor: 'var(--intervento-periodico-light)',
                          }}
                          className="p-2 w-100 mt-1"
                        >
                          <div className="p-sm text-intervento-periodico d-flex justify-content-between align-items-center w-100">
                            <span>{eventsInSameDayInterventoPeriodico > 1 ? 'Periodiche' : 'Periodica'}</span>
                            {eventsInSameDayInterventoPeriodico}{' '}
                          </div>
                        </div>
                      </div>
                    </Link>
                  )
                }
                return (
                  <Link
                    to={`/interventi/?cliente=${
                      args.event._def.extendedProps.pk_cliente
                    }&stato=programmato&data_intervento__gte=${dayjs(args.event.start).format(
                      'YYYY-MM-DD'
                    )}&data_intervento__lte=${dayjs(args.event.end).format('YYYY-MM-DD')}`}
                    className="no-link w-100 month-event"
                  >
                    <div
                      className={classNames('p-2', 'text-wrap', {
                        'bg-rapporto-taratura-light':
                          args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura',
                        'bg-intervento-periodico-light':
                          args.event._def.extendedProps.tipo_intervento === 'verifica_periodica',
                      })}
                      style={{
                        borderLeft: `4px solid ${
                          args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura'
                            ? 'var(--rapporto-taratura-strong)'
                            : 'var(--intervento-periodico-strong)'
                        }`,
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div
                          className={classNames('badge bg-white', {
                            'text-rapporto-taratura':
                              args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura',
                            'text-intervento-periodico':
                              args.event._def.extendedProps.tipo_intervento === 'verifica_periodica',
                          })}
                        >
                          {args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura'
                            ? 'Taratura'
                            : 'Periodica'}
                        </div>
                        <div
                          className={classNames('d-flex align-items-center', {
                            'text-rapporto-taratura':
                              args.event._def.extendedProps.tipo_intervento === 'rapporto_taratura',
                            'text-intervento-periodico':
                              args.event._def.extendedProps.tipo_intervento === 'verifica_periodica',
                          })}
                        ></div>
                      </div>
                      <div className="heading-h6 mt-2">{args.event.title}</div>
                      <div className="text-body-secondary">{args.event._def.extendedProps.sede}</div>
                      <div className="text-body-secondary d-flex align-items-center">
                        <span
                          className="material-icons me-1 text-intervento-periodico"
                          style={{
                            fontSize: '16px',
                          }}
                        >
                          scale
                        </span>
                        {args.event._def.extendedProps.bilance_count
                          ? args.event._def.extendedProps.bilance_count + ' Bilance'
                          : '1 Bilancia'}
                        {/* {args.event._def.extendedProps.durata_stimata && args.event._def.extendedProps.durata_stimata !== 0 && (
                          <span className="ms-2 d-flex align-items-center">
                            <span
                              className="material-icons me-1"
                              style={{
                                fontSize: '16px',
                              }}
                            >
                              schedule
                            </span>
                            {args.event._def.extendedProps.durata_stimata?.substring(
                              0,
                              args.event._def.extendedProps.durata_stimata?.length - 3
                                
                            )}
                          </span>
                        )} */}
                      </div>
                    </div>
                  </Link>
                )
              }}
            />
          </div>
        </div>
      </div>
      {modalStatePianificaPeriodica.isOpen && (
        <ModalPianificazionePeriodica
          isOpen={modalStatePianificaPeriodica.isOpen}
          toggle={modalActionsPianificaPeriodica.toggle}
          save={async (values: any) => {
            await fetchApi(`${API_URL}/bilance/intervento/pianifica/`, {
              method: 'POST',
              body: JSON.stringify(values),
              headers: {
                Authorization: `Bearer ${tokens?.access}`,
                'Content-Type': 'application/json',
              },
            }).then(() => {
              refetch()
              modalActionsPianificaPeriodica.close()
            })
          }}
        />
      )}
      {modalStatePianificaTaratura.isOpen && (
        <ModalPianificazioneTaratura
          isOpen={modalStatePianificaTaratura.isOpen}
          toggle={modalActionsPianificaTaratura.toggle}
          save={async (values: any) => {
            await fetchApi(`${API_URL}/bilance/intervento/pianifica-tarature/`, {
              method: 'POST',
              body: JSON.stringify(values),
              headers: {
                Authorization: `Bearer ${tokens?.access}`,
                'Content-Type': 'application/json',
              },
            }).then(() => {
              refetch()
              modalActionsPianificaTaratura.close()
            })
          }}
        />
      )}
    </div>
  )
}
